import React from "react";
import ReviewsSection from "../components/ReviewsSection";

export default function About() {
  return (
    <div className="bg-white text-neutral-900 min-h-screen">
      {/* Page Header */}
      <section className="bg-black text-white py-16 border-b border-neutral-900 text-center relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src="https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/4b0ed4f1-460c-426e-a80d-63f8321daac9.jpg"
            alt="Om os baggrund"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-neutral-400 block mb-2">
            Historien bag
          </span>
          <h1 className="text-4xl md:text-5xl font-serif font-bold tracking-tight">
            Om os
          </h1>
          <p className="text-sm text-neutral-400 max-w-lg mx-auto leading-relaxed">
            Hillerød Smørrebrød er din lokale smørrebrødsforretning. Vi har leveret højtbelagt smørrebrød og lækre sandwich til Hillerød og omegn i over et årti.
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <img
                src="https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/53240b71-1624-437a-8c9d-0f732bdcae67.jpg"
                alt="Hillerød Smørrebrød Butik"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
          <div className="lg:col-span-7 space-y-6">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#2d5a27] block">
              Lokalt håndværk siden 2016
            </span>
            <h2 className="text-3xl font-serif font-bold text-neutral-900 tracking-tight">
              10 års erfaring med passion for smørrebrød
            </h2>
            <p className="text-neutral-600 leading-relaxed">
              Hillerød Smørrebrød er en stolt, lokal virksomhed med over 10 års erfaring i at lave klassisk dansk smørrebrød og lækre sandwich. Vi brænder for det gode håndværk og de stolte madtraditioner.
            </p>
            <p className="text-neutral-600 leading-relaxed">
              Vores filosofi er simpel: Vi fokuserer altid på tre kerneværdier – <strong>kompromisløs kvalitet</strong>, <strong>god og personlig service</strong> samt en <strong>fornuftig pris</strong>, hvor alle kan være med. Hver eneste stykke smørrebrød smøres med omhu og passion, så du altid får en smagsoplevelse ud over det sædvanlige.
            </p>
          </div>
        </div>
      </section>

      {/* Dedicated Reviews Section */}
      <ReviewsSection limit={6} title="Hvad vores gæster siger om os" subtitle="Kundernes oplevelser" />
    </div>
  );
}
